export enum FIELDS {
  FULL_NAME = 'fullName',
  COMPANY = 'company',
  FCA_NUMBER = 'fcaNumber',
  FCA_STATUS = 'fcaStatus',
  LMC_STATUS = 'lmcStatus',
  FULL_ADDRESS = 'fullAddress',
  POSTCODE = 'postcode',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  HOUSE_NUMBER = 'houseNumber',
  CITY = 'city',
  COUNTY = 'county',
  PHONE = 'phone',
  EMAIL_ADDRESS = 'emailAddress',
}

export enum FIELDS_LABELS {
  FULL_NAME = 'Full name',
  COMPANY = 'Company',
  FCA_NUMBER = 'FCA Number',
  FCA_STATUS = 'FCA status',
  LMC_STATUS = 'LMC status',
  FULL_ADDRESS = 'Full address',
  POSTCODE = 'Postcode',
  HOUSE_NUMBER = 'Address line 1',
  ADDRESS_LINE_1 = 'Address line 2',
  ADDRESS_LINE_2 = 'Address line 3',
  CITY = 'City',
  COUNTY = 'County',
  PHONE = 'Phone no.',
  EMAIL_ADDRESS = 'Email address',
}

export enum RADIO_VALUES {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export type FcaStatuses = RADIO_VALUES.ACTIVE | RADIO_VALUES.INACTIVE;
